import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TTabName } from './ParameterValuesMixedHandlers';

export type TEnhancedParamDataTableData = {
  primaryKey: number | string,
  id: string,
  label: string,
  defaultValue: string,
  minValue: string | number,
  maxValue: string | number,
  value: string | number,
  // value2: string | number,
  [x: string]: string | number | boolean,
};

type Props = {
  isLoading: boolean | undefined,
  tabName: TTabName,
  handleEdit: (row: any, tabName: TTabName) => void,
};

export function getEnhancedandGABParamDataTableColumns({
  isLoading,
  handleEdit,
  tabName,
}: Props) {
  // console.table(meta.rowsFields);
  const cond = tabName === 'Paramètre Temps';

  const columnHelper = createColumnHelper<TEnhancedParamDataTableData>();

  const arr = cond ? [] : [columnHelper.accessor('defaultValue', {
    id: 'defaultValue',
    header: 'Default Value',
    cell: (props) => {
      return (
        <Skeleton isLoaded={!isLoading}>
          <Center>{props.getValue()}</Center>
        </Skeleton>
      );
    },
  }),

  columnHelper.accessor('minValue', {
    id: 'minValue',
    header: 'Min Value',
    cell: (props) => {
      return (
        <Skeleton isLoaded={!isLoading}>
          <Center>{props.getValue()}</Center>
        </Skeleton>
      );
    },
  }),

  columnHelper.accessor('maxValue', {
    id: 'maxValue',
    header: 'Max Value',
    cell: (props) => {
      return (
        <Skeleton isLoaded={!isLoading}>
          <Center>{props.getValue()}</Center>
        </Skeleton>
      );
    },
  }),];

  return [
    columnHelper.accessor('id1', {
      id: 'id1',
      header: 'Id',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('label', {
      id: 'label',
      header: 'Label',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    ...arr,

    columnHelper.accessor('value', {
      id: 'value',
      header: 'Value',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row, tabName)}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
